import axios from 'axios';

export const state = {
  trades: [],
  loading: false,
};

export const mutations = {
  setCancellableTrades(context, trades) {
    context.trades = trades;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async fetchCancellableTrades({ commit, rootState }) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);
      const trades = await axios.get(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/trades/cancellable`, options)
        .then(response => response.data);

      commit('setCancellableTrades', trades);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async deleteCancellableTrades({ commit, dispatch, rootState }, data) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
        data,
      };

      commit('setLoading', true);

      await axios.delete(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/trades/cancellable`, options)
        .then(response => response.data);

      commit('setLoading', false);

      dispatch('fetchCancellableTrades');
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const tradesStore = {
  state,
  mutations,
  actions,
};

export default tradesStore;



// WEBPACK FOOTER //
// ./src/store/trades/cancellableTradesStore.js